
import { computed, defineComponent } from 'vue';

export default defineComponent({
  name: 'InformationFooter',
  setup() {
    const nowYear = computed(() => new Date().getFullYear());

    return {
      nowYear,
    };
  },
});
